angular.module('elfium').controller('businessCaseDetailModalController', ['$scope', '$uibModalInstance', '$uibModal', '$timeout', '$q', 'businessCaseService', 'elfiumToastrService', 'elfiumModalFactory', 'elfiumRelatedOptionsService', 'elfiumUrlService', 'elfiumMissingRequiredFieldsFilter', 'businessCaseId', 'ELFIUM_SELECT_OPTIONS', 'BUSINESS_CASE_REQUIRED_FIELDS',
    function ($scope, $uibModalInstance, $uibModal, $timeout, $q, businessCaseService, elfiumToastrService, elfiumModalFactory, elfiumRelatedOptionsService, elfiumUrlService, elfiumMissingRequiredFieldsFilter, businessCaseId, ELFIUM_SELECT_OPTIONS, BUSINESS_CASE_REQUIRED_FIELDS) {
        var that = this;
        that.elfiumModal = null;
        $scope.businessCaseDetailModalBody = elfiumUrlService.getTemplateUrl('businessCase', 'businessCaseDetailModalBody');
        $scope.selectOptions = ELFIUM_SELECT_OPTIONS;
        $scope.reports = {
            updateReportsCallback: $q.resolve,
            isDirty: false
        };
        that.initialize = function () {
            businessCaseService.getBusinessCase(businessCaseId).then(function (businessCase) {
                $scope.businessCase = businessCase;
                that.unchangedObject = angular.copy(businessCase);
                that._registerClosingEventListener();
                that.getRelatedOptions();
            }, elfiumToastrService.error);
        };
        that.areReportsDirty = function () {
            return $scope.reports.isDirty;
        };
        that.getRelatedOptions = function () {
            elfiumRelatedOptionsService.getCompanyOptions().then(function (companyOptions) {
                $scope.companyOptions = companyOptions;
            }, elfiumToastrService.error);
            elfiumRelatedOptionsService.getUserOptions().then(function (userOptions) {
                $scope.userOptions = userOptions;
            }, elfiumToastrService.error);
        };
        that.getRelatedContactOptionsForCompany = function (companyId) {
            elfiumRelatedOptionsService.getContactOptionsForCompany(companyId).then(function (contactOptions) {
                $scope.contactOptions = contactOptions;
            }, elfiumToastrService.error);
        };
        that.updateBusinessCase = function () {
            businessCaseService.updateBusinessCase($scope.businessCase).then($scope.reports.updateReportsCallback).then(function () {
                that.unchangedObject = angular.copy($scope.businessCase);
                $scope.reports.isDirty = false;
                elfiumToastrService.success('Obchodní případ uložen');
                $uibModalInstance.close();
            }, elfiumToastrService.error);
        };
        that._reallyCloseModal = function () {
            return $uibModal.open({
                templateUrl: elfiumUrlService.getTemplateUrl('elfium', 'elfiumUnsavedChangesModal'),
                size: 'sm'
            });
        };
        that._shouldShowConfirmation = function () {
            return !angular.equals($scope.businessCase, that.unchangedObject) || that.areReportsDirty();
        };
        that._registerClosingEventListener = function () {
            $scope.$on('modal.closing', function ($event) {
                if (that._shouldShowConfirmation()) {
                    that._showCloseConfirmationAndClose($event);
                }
            });
        };
        that._showCloseConfirmationAndClose = function ($event) {
            $event.preventDefault();
            that._reallyCloseModal().result.then(function () {
                angular.extend(that.unchangedObject, $scope.businessCase);
                $scope.reports.isDirty = false;
                $uibModalInstance.dismiss();
            });
        };
        $scope.prefillReportCastkaFields = function () {
            var castka = $scope.businessCase.obchodniPripadReport.anoChciNabidkuCastka;
            $scope.businessCase.obchodniPripadReport.predaniNabidkyCastka = castka;
            $scope.businessCase.obchodniPripadReport.rozhodnutiONabidceCastka = castka;
            $scope.businessCase.obchodniPripadReport.podpisCastka = castka;
        };
        $scope.okClicked = function () {
            $timeout(function () {
                var missingRequiredFields = elfiumMissingRequiredFieldsFilter($scope.businessCase, BUSINESS_CASE_REQUIRED_FIELDS);
                if (missingRequiredFields.length) {
                    elfiumToastrService.error('Vyplňte povinné údaje: ' + missingRequiredFields.join(', '));
                } else {
                    that.updateBusinessCase();
                }
            });
        };
        $scope.getPriorityButtonLabel = function () {
            return ($scope.businessCase && $scope.businessCase.priorita) ? 'Zrušit prioritní' : 'Nastavit prioritní';
        };
        $scope.togglePriority = function () {
            $scope.businessCase.priorita = !$scope.businessCase.priorita;
            $scope.okClicked();
        };
        $scope.$watch('businessCase.firmaId', function (newValue) {
            if (newValue) {
                that.getRelatedContactOptionsForCompany(newValue);
            }
        });
        that.initialize();
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/businessCase/businessCaseDetailModalController.ts